import { Component, Vue, Inject } from "vue-property-decorator";
import appconst from "../appconst";
import AbpBase from "./abpbase";
import { ElForm } from "element-ui/types/form";

export default abstract class FormBase extends AbpBase {
  saving = false;

  abstract rules: object;

  save(): void {
    this.validateForm().then(result => {
      if (result) {
        this.saving = true;
        this.submitExecute()
          .then(() => {
            this.$notify.success("操作成功");
            this.back();
          })
          .finally(() => {
            this.saving = false;
          });
      }
    });
  }
  abstract submitExecute(): Promise<void>;

  validateForm(): Promise<Boolean> {
    return new Promise(resolve => {
      this.validateFormExecute(resolve);
    });
  }

  validateFormExecute(resolve: any): void {
    (this.$refs.form as ElForm).validate(valid => {
      resolve(valid);
    });
  }

  back() {
    this.$router.back();
  }
}
